<template>
    <v-dialog
			v-model="showMap"
			width="85%"
		>
			<v-card
				min-height="500"
			>
        		<v-toolbar color="secondary" dense flat class="white--text">
					<v-toolbar-title class="font-weight-bold">{{
						$t("Primary Geofence")
					}}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon class="white--text" @click="closeModal">
						<v-icon>mdi-close</v-icon>
					</v-btn>
            	</v-toolbar>
        		<v-card-text>
          			<v-container>
						<v-row class="d-flex">
							<v-col cols="3">
                                <div class="text-h5 black--text font-weight-bold">Farm Location</div>
                                    <v-text-field
                                        outlined
                                        dense
                                        @input="getGoogleAddress"
                                    ></v-text-field>
                                    <!-- <input 
                                        type="text" 
                                        id="autocomplete" 
                                        name="fname"
                                        ref="autocomplete" 
                                    /> -->
                                <div class="mt-4 subtitle-1 black--text font-weight-bold">Address </div>

                                <div class="text-h5 black--text font-weight-bold">Geographic Location</div>

                                <div class="mt-4 subtitle-1 black--text font-weight-bold">Latitude  </div>
								<v-text-field
                                    v-model="latitude"
                                    outlined
                                    dense
								></v-text-field>

                                <div class=" subtitle-1 black--text font-weight-bold">Longitude</div>
                                <v-text-field
                                    v-model="longitude"
                                    outlined
                                    dense
								></v-text-field>


                                <v-btn @click="closeModal" block color="primary" depressed>Save</v-btn>
							</v-col>
							<v-col cols="9">
								<div class="google-map" style="width:100%;height:520px" id="map" ref="googleMap"></div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader';
import axios from 'axios';

export default {
    async mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
        document.head.appendChild(recaptchaScript)
        const success = (position) => {
            this.latitude  = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.mapOptions.center.lat = this.latitude;
            this.mapOptions.center.lng = this.longitude;
        };
        

        const error = (err) => {
            console.log(err)
        };

        // This will open permission popup
        await navigator.geolocation.getCurrentPosition(success, error);
        try {
            const loader = await new Loader({
                apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
                libraries: ["places", "map"]
            }).load()
            .then((google) => {
                this.google = google;
                this.initializeMap(google);
            })
            .catch(e => {
                console.log('Map', e);
            });
            this.loader = loader;
        
        }catch(e) {
            console.log(e);
        }
    },
    props: {
        showMap: {
            type: Boolean,
            require: true
        }
    },

    data() {
        return {
            loader: null,
            latitude: 0,
            longitude: 0,
            google: null,
            map: null,
            marker: null,
            mapOptions: {
                center: {
                    lat: -34.397,
                    lng: 150.644
                },
                styles: {
                    overflow: 'visible'
                },
                zoom: 6
            },
        }
    },

    methods: {
        getGoogleAddress() {
            var config = {
                method: 'get',
                url: 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=amoeba&types=establishment&location=37.76999%2C-122.44696&radius=500&key=AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4',
                headers: { }
            };

            axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        closeModal() {
            this.$emit('close-location-modal', {
                lat: this.latitude,
                lng: this.longitude
            });
        },

        async initializeMap(google) {
            const mapContainer = this.$refs.googleMap
            this.map = await new google.maps.Map(mapContainer, this.mapOptions);
            this.marker = await new google.maps.Marker({
                position: this.mapOptions.center,
                map: this.map,
            });
            this.marker.setIcon('http://maps.google.com/mapfiles/ms/icons/green-dot.png');

            this.map.addListener("click", (mapsMouseEvent) => {
                const latLng = mapsMouseEvent.latLng.toJSON();
                this.marker.setPosition(latLng);
                this.latitude = latLng.lat;
                this.longitude = latLng.lng;
            });

             const center = { lat: 40.84498856765032, lng: -73.71060855293794 };
            // Create a bounding box with sides ~10km away from the center point
            const defaultBounds = {
                north: center.lat + 0.1,
                south: center.lat - 0.1,
                east: center.lng + 0.1,
                west: center.lng - 0.1,
            };
            // const input = this.$refs.autocomplete;
            const options = {
                types: ["cities"],
                bounds: defaultBounds,
                fields: ["place_id", "geometry", "name", "address_components"],
            };
            let location = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), options);
            console.log(location);
        },

    }
}

</script>